export default __webpack_public_path__ + "static/media/pic8.6b896ac1.jpg";